import { render, staticRenderFns } from "./EvaluationProject.vue?vue&type=template&id=2959862d&scoped=true&"
import script from "./EvaluationProject.vue?vue&type=script&lang=ts&"
export * from "./EvaluationProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2959862d",
  null
  
)

export default component.exports